import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { BenefitEnrollmentStep } from '../models/pension-enrollment-models';

export function useBenefitEnrollmentStep() {

	return useSelector<TcsmStates, BenefitEnrollmentStep>(state => state?.newHireEnrollmentState?.currentEnrollmentStep);

}